<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@if (dialogMode === 'initial') {
  <web-design-system-button size="small" (click)="startEdit()">
    {{ 'user-self-service.tax.vvt-reset.headline' | transloco }}
  </web-design-system-button>
}

@if (dialogMode === 'edit' || dialogMode === 'verify') {
  <div class="mb-3">
    <h5>{{ 'user-self-service.tax.vvt-reset.headline' | transloco }}</h5>
  </div>
  <form class="row" (ngSubmit)="onSubmit(f)" #f="ngForm">
    <div class="d-flex flex-column ml-3">
      <div class="custom-control custom-radio">
        <input
          type="radio"
          id="c1"
          name="chooseVVTResetType"
          required
          class="custom-control-input"
          [(ngModel)]="editData.selected"
          [value]="'both'"
        />
        <label for="c1" class="custom-control-label">{{ 'user-self-service.tax.vvt-reset.radiobutton1' | transloco }}</label>
      </div>
      <div class="custom-control custom-radio">
        <input
          type="radio"
          id="c2"
          name="chooseVVTResetType"
          required
          class="custom-control-input"
          [(ngModel)]="editData.selected"
          [value]="'stocks'"
        />
        <label for="c2" class="custom-control-label">{{ 'user-self-service.tax.vvt-reset.radiobutton2' | transloco }}</label>
      </div>
      <div class="custom-control custom-radio">
        <input
          type="radio"
          id="c3"
          name="chooseVVTResetType"
          required
          class="custom-control-input"
          [(ngModel)]="editData.selected"
          [value]="'other'"
        />
        <label for="c3" class="custom-control-label">{{ 'user-self-service.tax.vvt-reset.radiobutton3' | transloco }}</label>
      </div>
    </div>
    <div class="col-12 mt-3 font-smaller1">
      <p>{{ 'user-self-service.tax.vvt-reset.text-head-list' | transloco }}</p>
      <ul class="font-size-smaller1">
        <li>{{ 'user-self-service.tax.vvt-reset.listpoint1' | transloco }}</li>
        <li>{{ 'user-self-service.tax.vvt-reset.listpoint2' | transloco }}</li>
        <li>{{ 'user-self-service.tax.vvt-reset.listpoint3' | transloco }}</li>
        <li>{{ 'user-self-service.tax.vvt-reset.listpoint4' | transloco }}</li>
      </ul>
    </div>
    @if (dialogMode === 'edit') {
      <div class="col-12 d-flex flex-column margin-top-15 margin-bottom-15 justify-content-between">
        <span class="mb-3">{{ 'user-self-service.tax.vvt-reset.autorize-text' | transloco }}</span>
        <div>
          <web-design-system-button [disabled]="!f.valid || preconditionFailed" size="small" [isSubmit]="true">
            {{ 'user-self-service.tax.change-fsa.btn-continue' | transloco }}
          </web-design-system-button>
        </div>
      </div>
    }
  </form>
  @if (dialogMode === 'verify') {
    <p class="mt-3 border-bottom d-inline-block">{{ 'user-self-service.tax.vvt-reset.verify-text' | transloco }}</p>
    <p class="mb-1">
      {{ 'user-self-service.tax.vvt-reset.option1' | transloco }}
      {{ ['both', 'stocks'].indexOf(editData.selected) > -1 ? 'Ja' : 'Nein' }}
    </p>
    <p class="mb-1">
      {{ 'user-self-service.tax.vvt-reset.option2' | transloco }}
      {{ ['both', 'other'].indexOf(editData.selected) > -1 ? 'Ja' : 'Nein' }}
    </p>
    <web-components-transaction-auth [payload]="dataToAuthorize" (transactionResult)="authorizedTransactionResult($event)" />
  }
}

<div class="mt-4">
  <web-components-user-messages />
</div>
